var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: { backgroundBgWhite: !_vm.timeShow },
      attrs: { id: "page_Container" }
    },
    [
      _vm.timeShow
        ? _c("div", { attrs: { id: "membercenter" } }, [
            _c("div", { attrs: { id: "main-container" } }, [
              _c("div", { staticClass: "centerHeader" }, [
                _c("div", { staticClass: "header-wrapper" }, [
                  _c("div", {
                    staticClass: "headPortrait",
                    style: { backgroundImage: "url(" + _vm.headerImg + ")" },
                    on: { click: _vm.openInfo }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "bingling" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "nickName" }, [
                    _c("span", [_vm._v(_vm._s(_vm.Nickname))])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "header-distribution" }, [
                  _c("p", { staticClass: "txt" }, [
                    _vm._v("开通分销账户，推广分销得盈利")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isOpenRetailStore === 1,
                          expression: "isOpenRetailStore === 1"
                        }
                      ],
                      staticClass: "btn-distribution",
                      on: { click: _vm.toPage }
                    },
                    [_vm._v(_vm._s(_vm.distribution))]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isOpenRetailStore === 2,
                          expression: "isOpenRetailStore === 2"
                        }
                      ],
                      staticClass: "btn-distribution"
                    },
                    [_vm._v("敬请期待")]
                  )
                ]),
                _vm._v(" "),
                _vm._m(0)
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "myOrder" },
                [
                  _c(
                    "van-cell-group",
                    [
                      _c(
                        "van-cell",
                        {
                          attrs: {
                            title: "",
                            "is-link": "",
                            value: "全部订单"
                          },
                          on: {
                            click: function($event) {
                              _vm.orderClick("")
                            }
                          }
                        },
                        [
                          _c("template", { slot: "title" }, [
                            _c("span", [_vm._v("我的订单")])
                          ])
                        ],
                        2
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "myOrderlist" },
                    [
                      _c(
                        "van-row",
                        {
                          staticClass: "OrderListClass",
                          attrs: { type: "flex", justify: "center" }
                        },
                        _vm._l(_vm.orderTypeData, function(item) {
                          return _c(
                            "van-col",
                            { key: item.type, attrs: { span: "5" } },
                            [
                              _c(
                                "div",
                                {
                                  on: {
                                    click: function($event) {
                                      _vm.orderClick(item.type)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "van-tabbar-item",
                                    {
                                      attrs: {
                                        info: _vm.defaultData[item.quantity]
                                          ? _vm.defaultData[item.quantity]
                                          : null
                                      }
                                    },
                                    [
                                      _c("span", [_vm._v(_vm._s(item.name))]),
                                      _vm._v(" "),
                                      _c("img", {
                                        attrs: {
                                          slot: "icon",
                                          src: item.orderImg
                                        },
                                        slot: "icon"
                                      })
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "list-wrapper" },
                [
                  _c(
                    "van-cell-group",
                    [
                      _c(
                        "van-cell",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.isDistribution === 3 &&
                                _vm.isOpenRetailStore === 1,
                              expression:
                                "isDistribution === 3 && isOpenRetailStore === 1"
                            }
                          ],
                          attrs: {
                            title: "我的分销",
                            "is-link": "",
                            value: ""
                          },
                          on: { click: _vm.distributionClick }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "img",
                              attrs: { slot: "icon" },
                              slot: "icon"
                            },
                            [
                              _c("img", {
                                staticStyle: { width: "15px", height: "14px" },
                                attrs: { src: _vm.iconImg.connections, alt: "" }
                              })
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "van-cell",
                        {
                          attrs: {
                            title: "我的收藏",
                            "is-link": "",
                            value:
                              _vm.defaultData.accountCollectionQuantity + "个"
                          },
                          on: { click: _vm.collectClick }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "img",
                              attrs: { slot: "icon" },
                              slot: "icon"
                            },
                            [
                              _c("img", {
                                staticStyle: { width: "14px", height: "14px" },
                                attrs: { src: _vm.iconImg.collection, alt: "" }
                              })
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "van-cell",
                        {
                          attrs: {
                            title: "我的优惠",
                            "is-link": "",
                            value: _vm.defaultData.accountCardQuantity + "张"
                          },
                          on: { click: _vm.dicountClick }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "img",
                              attrs: { slot: "icon" },
                              slot: "icon"
                            },
                            [
                              _c("img", {
                                staticStyle: { width: "14px", height: "14px" },
                                attrs: { src: _vm.iconImg.discount, alt: "" }
                              })
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "van-cell",
                        {
                          attrs: {
                            title: "地址管理",
                            "is-link": "",
                            value: ""
                          },
                          on: { click: _vm.addressClick }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "img",
                              attrs: { slot: "icon" },
                              slot: "icon"
                            },
                            [
                              _c("img", {
                                staticStyle: { width: "12px", height: "16px" },
                                attrs: { src: _vm.iconImg.map, alt: "" }
                              })
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "van-cell",
                        {
                          attrs: {
                            title: "我的积分",
                            "is-link": "",
                            value: _vm.defaultData.accountPointQuantity
                          },
                          on: { click: _vm.pointClick }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "img",
                              attrs: { slot: "icon" },
                              slot: "icon"
                            },
                            [
                              _c("img", {
                                staticStyle: { width: "14px", height: "16px" },
                                attrs: { src: _vm.iconImg.brand, alt: "" }
                              })
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "van-cell",
                        {
                          attrs: {
                            title: "发票管理",
                            "is-link": "",
                            value: (_vm.defaultData.invoiceQuantity || 0) + "张"
                          },
                          on: { click: _vm.invoiceClick }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "img",
                              attrs: { slot: "icon" },
                              slot: "icon"
                            },
                            [
                              _c("img", {
                                staticStyle: { width: "14px", height: "16px" },
                                attrs: { src: _vm.iconImg.print, alt: "" }
                              })
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "van-cell",
                        {
                          attrs: {
                            title: "我的余额",
                            "is-link": "",
                            value: "¥0"
                          },
                          on: { click: _vm.balanceClick }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "img",
                              attrs: { slot: "icon" },
                              slot: "icon"
                            },
                            [
                              _c("img", {
                                staticStyle: { width: "8px", height: "14px" },
                                attrs: { src: _vm.iconImg.dollar, alt: "" }
                              })
                            ]
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "bottomText" }, [
                _c("div", { staticClass: "copyright" }, [
                  _vm._v("© 2019-" + _vm._s(new Date().getFullYear()) + " "),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://beian.miit.gov.cn/",
                        target: "_blank"
                      }
                    },
                    [_vm._v("浙ICP备17054838号")]
                  )
                ]),
                _vm._v(" "),
                _c("span", [_vm._v("易联云商城定制版-易联云提供技术支持")])
              ])
            ])
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header-member" }, [
      _c("div", { staticClass: "img" }),
      _vm._v(" "),
      _c("div", { staticClass: "txt" }, [
        _c("div", { staticClass: "title" }, [_vm._v("超级会员")]),
        _vm._v(" "),
        _c("div", { staticClass: "value" }, [
          _vm._v("会员推广专享特权·专属商品·优选折上折")
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }